"use client"

import { motion } from "framer-motion";
import {
    ChartSpline,
    Cable,
    Cloud,
    Plug,
    Terminal,
} from "lucide-react";
import { Products } from "@/types/productsTypes";

const integrationIconMap = {
    plug: Plug,
    cable: Cable,
    cloud: Cloud,
    terminal: Terminal,
    analytics: ChartSpline,
} as const;

export function Integrations({ section }: { section: Products["atlasai"]["integrations"] }) {
    return (
        <section className="section-primary">
            <div className="max-w-6xl mx-auto space-y-10">
                <div className="text-center space-y-4">
                    <span className="section-badge badge-size inline-block w-fit">
                        {section.badge}
                    </span>
                    <h2 className="title-size font-semibold text-bg">
                        {section.title}
                    </h2>
                    <p className="text-size text-muted-foreground max-w-3xl mx-auto">
                        {section.description}
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-3">
                    {section.items.map((item, index) => {
                        const Icon = item.icon ? integrationIconMap[item.icon as keyof typeof integrationIconMap] : Plug;
                        return (
                            <motion.div
                                key={item.title}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="rounded-3xl border bg-white p-6 shadow-sm"
                            >
                                <div className="iconBudg size-10 mb-3">
                                    <Icon className="size-5" />
                                </div>
                                <h3 className="text-lg font-semibold text-bg mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    {item.description}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>

                <p className="text-sm text-muted-foreground text-center">
                    {section.footer}
                </p>
            </div>
        </section>
    );
}
